import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useFieldArray } from "react-hook-form";
import { AddressControl, InputControl } from "@/components/controls";
import { Button, Divider } from "@/ui-kit";
import { PlusIcon, Trash2Icon } from "lucide-react";
import { AddressUtils } from "@/utils/address";
import "./index.css";

type IServiceAreasFormProps = {
  color?: "layer1" | "layer2";
};

export const ServiceAreasForm = ({
  color = "layer2",
}: IServiceAreasFormProps) => {
  const { t } = useTranslation();

  const { fields, append, remove } = useFieldArray({
    name: "serviceAreas",
  });

  const handleAddServiceArea = useCallback(() => {
    append({
      name: "",
      address: AddressUtils.getEmpty(),
    });
  }, [append]);

  const handleRemoveServiceArea = useCallback(
    (index: number) => {
      return () => {
        remove(index);
      };
    },
    [remove],
  );

  return (
    <>
      {fields.map((field, index) => (
        <div key={field.id} className="service-areas-form__area-section">
          <AddressControl
            name={`serviceAreas.${index}.address`}
            color={color}
          />
          <InputControl
            label={t("label.name")}
            name={`serviceAreas.${index}.name`}
            color={color}
          />
          {fields.length > 1 && (
            <div className="service-areas-form__area-footer">
              <Button
                size="sm"
                color={color}
                startIcon={<Trash2Icon />}
                content={t("action.delete")}
                onClick={handleRemoveServiceArea(index)}
              />
            </div>
          )}
        </div>
      ))}
      <Divider className="service-areas-form__area-divider" />
      <div>
        <Button
          className="service-areas-form__add-area"
          variant="ghost"
          color="layer2"
          startIcon={<PlusIcon />}
          content={t("action.add_what", {
            what: t("label.service_area").toLowerCase(),
          })}
          onClick={handleAddServiceArea}
        />
      </div>
    </>
  );
};
